// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--b3pm2","actions":"Footer-module--actions--1BSDu","copyright":"Footer-module--copyright--1sjsG"};